import * as defaultImport from "@splunk/dashboard-inputs";
export * from "@splunk/dashboard-inputs";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
